<template>
  <b-card>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loadingState"
    >
      <versions
        :selection-info="selectionInfo"
        @versions-loading-state="loadingState = $event"
      />
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BOverlay, BCard,
} from 'bootstrap-vue'
import { ref, reactive } from '@vue/composition-api'
import Versions from '../components/Versions.vue'

export default {
  components: {
    Versions,
    BOverlay,
    BCard,
  },
  setup(_, ctx) {
    const { zone, service, ...rest } = ctx.root.$route.query
    const loadingState = ref(true)
    const stepState = ref('zones')
    const selectionInfo = reactive({
      zone: zone || null,
      service: service || null,
      serviceClass: rest['service-class'] || null,
    })

    return {
      stepState,
      selectionInfo,
      loadingState,
    }
  },
}
</script>

<style>

</style>
